import { NavigationGuardNext, Route, RouteConfig } from 'vue-router';
import WarService from '@/services/War/WarService';
import { LIST_PERMISSION } from '@/constant/ListPermission';
import { NAME_ROUTES_CONQUISTAE } from '@/constant/War';

import { permissionWar } from '../Middleware/permission/War';
import { multiGuard } from '../Middleware/MultiGuard';

import Permission from '../Middleware/permission/index';

const ROUTES_AFTER_CONFIG = [
  NAME_ROUTES_CONQUISTAE.WAR_ROOM,
  NAME_ROUTES_CONQUISTAE.TRAINING_CENTER,
  NAME_ROUTES_CONQUISTAE.LEVELING_RESULT,
  NAME_ROUTES_CONQUISTAE.MISSION_LIST
];

let configLocal: any = null;
let cardLocal: any = null;

function redirectWar(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
  const PermissionClass = new Permission();
  const verifyPermissionWar = PermissionClass.can(LIST_PERMISSION.WAR);

  if (verifyPermissionWar) {
    next({
      name: NAME_ROUTES_CONQUISTAE.WELCOME
    });

    return;
  }

  next();
}

const beforeWar = async (to: Route, from: Route, next: NavigationGuardNext<Vue>) => {
  try {
    const War = new WarService();
    const config = configLocal || await War.getConfig();
    const { options } = config;
    if (!options?.length) {
      if (to.name === NAME_ROUTES_CONQUISTAE.CONFIG) {
        return next();
      }
      return next({ name: NAME_ROUTES_CONQUISTAE.CONFIG });
    }

    configLocal = config;

    try {
      const card = cardLocal || await War.getCardUser();
      cardLocal = card;
      if (ROUTES_AFTER_CONFIG.includes(to.name as string)) {
        return next();
      }
      return next({ name: NAME_ROUTES_CONQUISTAE.WAR_ROOM });

    } catch (error) {
      if (to.name === NAME_ROUTES_CONQUISTAE.LEVELING) {
        return next();
      }
      return next({ name: NAME_ROUTES_CONQUISTAE.LEVELING });
    }

  } catch (error) {
    if (to.name === NAME_ROUTES_CONQUISTAE.WELCOME) {
      return next();
    }
    return next({ name: NAME_ROUTES_CONQUISTAE.WELCOME });
  }
};

export const War: Array<RouteConfig> = [
  {
    path: '/conquistae',
    component: () => import('@/layouts/Default/index.vue'),
    children: [
      {
        path: '',
        name: NAME_ROUTES_CONQUISTAE.LAUNCH,
        component: () => import(/* webpackChunkName: "conquistae" */ '../../pages/War/pages/Launch/Launch.vue'),
        meta: { title: 'Conquistaê' },
        beforeEnter: redirectWar
      }
    ]
  },
  {
    path: '/conquistae',
    component: () => import('@/layouts/War/Welcome/index.vue'),
    children: [
      {
        path: 'bem-vindo',
        name: NAME_ROUTES_CONQUISTAE.WELCOME,
        component: () => import(
          /* webpackChunkName: "conquistae-welcome" */ '../../pages/War/pages/Welcome/Welcome.vue'
        ),
        meta: { title: 'Welcome - conquistaê' },
        beforeEnter: beforeWar
      }
    ]
  },
  {
    path: '/conquistae',
    component: () => import('@/layouts/War/Default/index.vue'),
    children: [
      {
        path: 'configuracao',
        name: NAME_ROUTES_CONQUISTAE.CONFIG,
        component: () => import(
          /* webpackChunkName: "conquistae-config" */ '../../pages/War/pages/Config/Config.vue'
        ),
        meta: { title: 'Configuração - conquistaê' },
        beforeEnter: multiGuard([
          permissionWar,
          beforeWar
        ])
      },
      {
        path: 'nivelamento',
        name: NAME_ROUTES_CONQUISTAE.LEVELING,
        component: () => import(
          /* webpackChunkName: "conquistae-leveling" */ '../../pages/War/pages/Leveling/Leveling.vue'
        ),
        meta: { title: 'Nivelamento - conquistaê' },
        beforeEnter: multiGuard([
          permissionWar,
          beforeWar
        ])
      },
      {
        path: 'nivelamento/resultado',
        name: NAME_ROUTES_CONQUISTAE.LEVELING_RESULT,
        component: () => import(
          /* webpackChunkName: "conquistae-leveling-result" */ '../../pages/War/pages/LevelingResult/LevelingResult.vue'
        ),
        meta: { title: 'Nivelamento - conquistaê' },
        beforeEnter: permissionWar
      },
      {
        path: 'lista-de-missao',
        name: NAME_ROUTES_CONQUISTAE.MISSION_LIST,
        component: () => import(/* webpackChunkName: "conquistae-training-center" */ '../../pages/War/pages/Mission/MissionList.vue'),
        meta: { title: 'Lista de Missão - conquistaê' },
        beforeEnter: permissionWar
      },
      {
        path: 'lista-de-missao/:id/resultado',
        name: NAME_ROUTES_CONQUISTAE.MISSION_LIST_RESULT,
        component: () => import(/* webpackChunkName: "conquistae-mission-list-result" */ '../../pages/War/pages/MissionListResult/MissionListResult.vue'),
        meta: { title: 'Resultado da Missão - conquistaê' },
        beforeEnter: permissionWar
      },
      {
        path: '',
        component: () => import(
          /* webpackChunkName: "conquistae-headquarters" */ '../../pages/War/pages/Headquarters/Headquarters.vue'
        ),
        children: [
          {
            path: 'quartel-de-operacoes',
            name: NAME_ROUTES_CONQUISTAE.WAR_ROOM,
            component: () => import(
              /* webpackChunkName: "conquistae-war-room" */ '../../pages/War/pages/WarRoom/WarRoom.vue'
            ),
            meta: { title: 'Quartel de Operações - conquistaê' },
            beforeEnter: multiGuard([
              permissionWar,
              beforeWar
            ])
          },
          {
            path: 'centro-de-treinamento',
            name: NAME_ROUTES_CONQUISTAE.TRAINING_CENTER,
            component: () => import(
              /* webpackChunkName: "conquistae-training-center" */ '../../pages/War/pages/TrainingCenter/TrainingCenter.vue'
            ),
            meta: { title: 'Centro de Treinamento - conquistaê' },
            beforeEnter: multiGuard([
              permissionWar,
              beforeWar
            ])
          }
        ]
      }
    ]
  }
];
